import { html, TemplateResult } from 'lit';

export function renderIdentityMonitoringDisabled(): TemplateResult {
  return html`
    <div class="d-flex align-items-start gap-1 mt-3">
      <gz-icon
        class="flex-shrink-0"
        name="ds-icon-notification_info"
        color="var(--blue-layout-400-primary)"
        size="24"
      ></gz-icon>

      <div class="d-flex flex-grow-1 flex-shrink-0 flex-basis-0 flex-column align-items-start gap-3">
        <div>
          <span class="text-secondary display-3-size text-bold mt-0" style="line-height: 24px;">No data available</span>
        </div>
        <div class="d-flex flex-column">
          <span class="text-secondary display-3-size">
            To begin retrieving data:
          </span>
          <ol class="d-flex flex-column">
            <li>
              <span class="text-secondary display-3-size">
                Enable <span class="text-secondary display-3-size text-bold">Identity monitoring</span> in the
                <span class="text-secondary display-3-size text-bold">Company state</span> widget on this page.
              </span>
            </li>
            <li>
              <span class="text-secondary display-3-size">
                Go to the <span class="text-secondary display-3-size text-bold">Identities</span> page and initiate a scan.
              </span>
            </li>
          </ol>
        </div>
      </div>
    </div>

  `
}
